// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JFXQnPikFgQ0uuHB5qwP {
  width: 100%;
  max-width: var(--campaign-tab-width);
  position: relative;
  align-items: center;
  background-color: #212121;
  border-radius: 8px;
  border: 1px solid rgba(39, 39, 39, 0.5);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 8px;
}
.JFXQnPikFgQ0uuHB5qwP[data-is-finished='true']::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--confetti-url);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  z-index: 0;
}
.RUJsdu5Ici5apTwhJ2d1 .mxPm5QVld2HCqDlZsJ5V {
  width: 80%;
  font-size: 29px;
  line-height: 24px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
}
.RUJsdu5Ici5apTwhJ2d1 .mxPm5QVld2HCqDlZsJ5V.kpPeT51gkDg_4N7fCYmF {
  font-size: 25px;
  letter-spacing: 0;
}
.RUJsdu5Ici5apTwhJ2d1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
  padding: 16px 0;
}
.YfMBf9Ttu2GLlq7aeaY1 {
  padding-bottom: 8px;
}
.i8R9fwrOugo3qlWTLBnM {
  width: 144px;
  height: 144px;
  object-fit: contain;
  position: relative;
  top: 20px;
}
.JGMzZuYKuZQgHd9IJFzQ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  position: relative;
  font-family: var(--font-family-primary, inherit);
}
.CDauCUBik8uhl21nVm3Z {
  position: relative;
  width: 259px;
  height: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.azroNGEh9wBv6BnkyYjM {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  color: white;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .azroNGEh9wBv6BnkyYjM {
    font-size: 12px;
  }
}
.D9seefE2g2Q0Eomq8aSR {
  width: 100%;
  max-width: 100%;
  margin-top: 9px;
  overflow: hidden;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .RUJsdu5Ici5apTwhJ2d1 .mxPm5QVld2HCqDlZsJ5V {
    width: 90%;
  }
  .RUJsdu5Ici5apTwhJ2d1 .mxPm5QVld2HCqDlZsJ5V.kpPeT51gkDg_4N7fCYmF {
    font-size: 16px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .JFXQnPikFgQ0uuHB5qwP {
    border-radius: 16px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .JFXQnPikFgQ0uuHB5qwP {
    border-radius: 16px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RewardsTab/FinishedTournamentReward/FinishedTournamentReward.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,mBAAmB;EACrB;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,mBAAmB;EACrB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".rewardContainer {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  position: relative;\n  align-items: center;\n  background-color: #212121;\n  border-radius: 8px;\n  border: 1px solid rgba(39, 39, 39, 0.5);\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n.rewardContainer[data-is-finished='true']::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: var(--confetti-url);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  z-index: 0;\n}\n.rewardContent .rewardText {\n  width: 80%;\n  font-size: 29px;\n  line-height: 24px;\n  letter-spacing: 0.08em;\n  text-align: center;\n  text-transform: uppercase;\n}\n.rewardContent .rewardText.noWin {\n  font-size: 25px;\n  letter-spacing: 0;\n}\n.rewardContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 1;\n  padding: 16px 0;\n}\n.rewardContentWithGiftSpinGames {\n  padding-bottom: 8px;\n}\n.finishedPrizeImage {\n  width: 144px;\n  height: 144px;\n  object-fit: contain;\n  position: relative;\n  top: 20px;\n}\n.textContentWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  font-family: var(--font-family-primary, inherit);\n}\n.prizeTextContainer {\n  position: relative;\n  width: 259px;\n  height: 60px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.secondaryText {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0;\n  text-align: center;\n  color: white;\n}\n@media (--campaign-mobile) {\n  .secondaryText {\n    font-size: 12px;\n  }\n}\n.giftSpinGamesList {\n  width: 100%;\n  max-width: 100%;\n  margin-top: 9px;\n  overflow: hidden;\n}\n@media (--campaign-mobile) {\n  .rewardContent .rewardText {\n    width: 90%;\n  }\n  .rewardContent .rewardText.noWin {\n    font-size: 16px;\n  }\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .rewardContainer {\n    border-radius: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rewardContainer": `JFXQnPikFgQ0uuHB5qwP`,
	"rewardContent": `RUJsdu5Ici5apTwhJ2d1`,
	"rewardText": `mxPm5QVld2HCqDlZsJ5V`,
	"noWin": `kpPeT51gkDg_4N7fCYmF`,
	"rewardContentWithGiftSpinGames": `YfMBf9Ttu2GLlq7aeaY1`,
	"finishedPrizeImage": `i8R9fwrOugo3qlWTLBnM`,
	"textContentWrapper": `JGMzZuYKuZQgHd9IJFzQ`,
	"prizeTextContainer": `CDauCUBik8uhl21nVm3Z`,
	"secondaryText": `azroNGEh9wBv6BnkyYjM`,
	"giftSpinGamesList": `D9seefE2g2Q0Eomq8aSR`
};
export default ___CSS_LOADER_EXPORT___;
